import { computed, ref } from 'vue'
import { fetchUnreadMessagesCount } from '@/features/whatsapp-conversations/api/whatsapp-conversations.api'
import { logError } from '@/common/utils/errors/error-handlers'
import { throttle } from '@/common/utils/throttle'

// one minute
const INTERVAL_MS = 1000 * 60

export const useUnreadCounterPolling = () => {
  const unreadMessagesCount = ref(0)
  const unreadMessagesCounterText = computed(() => {
    const count = unreadMessagesCount.value
    if (!count) {
      return ''
    }
    // we never show anything above 100, and our endpoint never returns >100
    return count >= 100 ? '99+' : `${count}`
  })

  const timerId = ref<ReturnType<typeof setInterval>>()

  const updateUnreadCounter = async () => {
    try {
      unreadMessagesCount.value = await fetchUnreadMessagesCount()
    } catch (e) {
      logError(e)
    }
  }

  // We do not want it to be called too many times, its not a priority task
  const throttledUpdateUnreadCounter = throttle(updateUnreadCounter, 3000)

  const startPolling = () => {
    clearInterval(timerId.value)
    throttledUpdateUnreadCounter()
    timerId.value = setInterval(throttledUpdateUnreadCounter, INTERVAL_MS)
  }

  const stopPolling = () => clearInterval(timerId.value)

  return { throttledUpdateUnreadCounter, startPolling, stopPolling, unreadMessagesCount, unreadMessagesCounterText }
}
